import React, { useEffect } from "react"
import styled from "styled-components"
import breakpoints from "../../styles/breakpoints"
import colors from "../../styles/colors"
import fonts from "../../styles/fonts"

const StyledKlarna = styled.div`
  padding: 0;
  #klarna-widget::part(osm-container) {
    ${fonts.openSans};
    color: ${(props) => (props.$white ? colors.white : colors.black)};
    background-color: transparent;
    border: none;
    text-align: left;
    padding-left: 0;
  }

  #klarna-widget::part(osm-logo) {
    color: ${(props) => (props.$white ? colors.white : colors.black)};
  }
  #klarna-widget::part(osm-cta) {
    color: ${(props) => (props.$white ? colors.white : colors.black)};
  }
  @media (min-width: ${breakpoints.md}) {
    padding: 0 32px;
  }
  @media (min-width: ${breakpoints.lg}) {
    padding: 0;
  }
`

const KlarnaWidget = ({ price, white = false }) => {
  const activeEnv =
    process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || "development"

  return (
    <StyledKlarna $white={white ? 1 : 0}>
      <klarna-placement
        id="klarna-widget"
        data-key="credit-promotion-auto-size"
        data-locale={activeEnv === "uk" ? "en-GB" : "en-US"}
        data-purchase-amount={price}
      ></klarna-placement>
    </StyledKlarna>
  )
}

export default KlarnaWidget
